import React, { useEffect, useState } from "react";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import { FaEye } from "react-icons/fa";
import { fetchGalleryData } from "../../services/gallery.service";
import * as bootstrap from "bootstrap";
import './gallery.component.css';
import config from '../../environment/config';

const GalleryMainView = () => {

  const API_URL = config.API_URL;
  const [gallery, setGallery] = useState([]);
  const [activeTab, setActiveTab] = useState("ALL");
  const [currentIndex, setCurrentIndex] = useState(null);
  const [autoPlay, setAutoPlay] = useState(false);

  const fetchGallleryList = async () => {
    try {
      const list = await fetchGalleryData();
      setGallery(list || []);
    } catch (error) {
      console.error("Error fetching event notices:", error);
    }
  };

  useEffect(() => {
    fetchGallleryList();
  }, []);

  useEffect(() => {
    let timer;
    if (autoPlay && currentIndex !== null) {
      timer = setTimeout(() => {
        goToNext();
      }, 3000); // auto-next every 3 seconds
    }
    return () => clearTimeout(timer);
  }, [autoPlay, currentIndex]);

  const groupedByYear = gallery.reduce((acc, item) => {
    const year = item.year;
    if (!acc[year]) acc[year] = [];
    acc[year].push(item);
    return acc;
  }, {});

  const sortedYears = Object.keys(groupedByYear).sort((a, b) => Number(b) - Number(a));

  const handlePreview = (index) => {
    if (index >= 0 && index < images.length && images[index]?.imageUrl) {
      setCurrentIndex(index);
      setAutoPlay(true);
      const modal = new bootstrap.Modal(document.getElementById("lightboxModal"));
      modal.show();
    } else {
      console.warn("Invalid image index or missing imageUrl:", index);
    }
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const getImagesToShow = () => {
    if (activeTab === "ALL") {
      return sortedYears.flatMap(year => groupedByYear[year]);
    } else {
      return groupedByYear[activeTab] || [];
    }
  };

  const images = getImagesToShow();

  return (
    <>
      <Helmet>
        <title>ABOUT US SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
        <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <HeaderComponent />
      <NavbarComponent />
      <section id="fixed-sub-nav" className="gradient-background" style={{ paddingBottom: '30px', paddingTop: '30px' }}>
        <div className="container pt-4">
          <div className="text-center">
            <div className="subscription-title mb-4">
              <h1>Gallery List</h1>
            </div>
            {(gallery.length>0 ? (
            <>
            <ul className="nav nav-pills mb-4 flex-wrap justify-content-center">
              <li className="nav-item">
                <button
                  className={`nav-link gallery-tab ${activeTab === "ALL" ? "active" : ""}`}
                  onClick={() => setActiveTab("ALL")}
                >
                  ALL
                </button>
              </li>
              {sortedYears.map((year) => (
                <li className="nav-item" key={year}>
                  <button
                    className={`nav-link gallery-tab ${activeTab === year ? "active" : ""}`}
                    onClick={() => setActiveTab(year)}
                  >
                    {year}
                  </button>
                </li>
              ))}
            </ul>
            <section className="gallery">
              {images.map((img, idx) => (
                <div className="image shadow-card p-1" key={idx}>
                  <img
                    src={`${API_URL}uploads/${img.imageUrl}`}
                    className="img-fluid"
                    alt={img.description}
                    loading="lazy"
                    onClick={() => handlePreview(idx)}
                    style={{ cursor: "pointer" }}
                  />
                  <div className="gallery-overlay">
                    <button
                      className="btn btn-light me-2 btn-sm"
                      onClick={() => handlePreview(idx)}
                    >
                      <FaEye />
                    </button>
                  </div>
                </div>
              ))}
            </section>

            {/* Bootstrap Modal */}
            <div
              className="modal fade"
              id="lightboxModal"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content bg-dark">
                  <div className="modal-body text-center position-relative">
                    {currentIndex !== null && images[currentIndex] && (
                      <img
                        src={`${API_URL}uploads/${images[currentIndex].imageUrl}`}
                        alt=""
                        className="img-fluid rounded"
                        style={{ maxHeight: "80vh", objectFit: "contain" }}
                      />
                    )}
                    {/* Navigation Buttons */}
                    <button
                      className="btn btn-light position-absolute top-50 start-0 translate-middle-y"
                      onClick={goToPrev}
                    >
                      ‹
                    </button>
                    <button
                      className="btn btn-light position-absolute top-50 end-0 translate-middle-y"
                      onClick={goToNext}
                    >
                      ›
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </>
            ) : 
           <div style={{height:'42vh'}}>
              <h4>No gallery</h4>
           </div>
          )}
          </div>
        </div>
      </section>
      <FooterComponent />
    </>
  );
};

export default GalleryMainView;
